export default "https://cdn.questicon.mathletics.com/assets/images/chevron-right-25b392abe78cbee91475c97023f68469.svg";